"use strict";

exports.__esModule = true;
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function GradientBar(props) {
  var _props$x = props.x,
    x = _props$x === void 0 ? 0 : _props$x,
    _props$endY = props.endY,
    endY = _props$endY === void 0 ? 0 : _props$endY,
    _props$width = props.width,
    width = _props$width === void 0 ? 0 : _props$width,
    _props$height = props.height,
    height = _props$height === void 0 ? 0 : _props$height;
  var nodeArray = [];
  var barHeight = height / 9;
  var partY = endY - barHeight;
  for (var _i = 0, _arr = [125, 2, 33]; _i < _arr.length; _i++) {
    var hue = _arr[_i];
    for (var lightness = 20; lightness < 100; lightness += 30) {
      var color = "hsl(" + hue + ", 100%, " + lightness + "%)";
      nodeArray.push(/*#__PURE__*/_react["default"].createElement("rect", {
        key: x + " " + partY + color,
        x: x,
        y: partY,
        width: width,
        height: barHeight,
        fill: color
      }));
      partY = partY - barHeight;
    }
  }
  return nodeArray;
}
function Bars(props) {
  var _props$width2 = props.width,
    width = _props$width2 === void 0 ? 0 : _props$width2,
    _props$x2 = props.x,
    x = _props$x2 === void 0 ? 0 : _props$x2,
    _props$height2 = props.height,
    height = _props$height2 === void 0 ? 0 : _props$height2;
  var barWidth = width / 5;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(GradientBar, _extends({}, props, {
    endY: height,
    width: barWidth
  })), /*#__PURE__*/_react["default"].createElement("rect", _extends({}, props, {
    x: x + barWidth * 2,
    width: barWidth,
    fill: "#ffffff"
  })), /*#__PURE__*/_react["default"].createElement(GradientBar, {
    endY: height,
    height: height * 0.8,
    x: x + barWidth * 2,
    width: barWidth
  }), /*#__PURE__*/_react["default"].createElement("rect", _extends({}, props, {
    x: x + barWidth * 3,
    width: barWidth / 2,
    fill: "#ffffff"
  })), /*#__PURE__*/_react["default"].createElement(GradientBar, {
    endY: height,
    height: height * 0.5,
    x: x + barWidth * 3.5,
    width: barWidth
  }));
}
function ActivitiesChartThumbnail(props) {
  var _props$x3 = props.x,
    x = _props$x3 === void 0 ? 0 : _props$x3,
    _props$y = props.y,
    y = _props$y === void 0 ? 0 : _props$y,
    _props$width3 = props.width,
    width = _props$width3 === void 0 ? 0 : _props$width3,
    _props$height3 = props.height,
    height = _props$height3 === void 0 ? 0 : _props$height3;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    width: width,
    height: height,
    x: x,
    y: y
  }, /*#__PURE__*/_react["default"].createElement("rect", {
    x: x,
    y: y,
    width: width,
    height: height,
    fill: "#ffffff"
  }), /*#__PURE__*/_react["default"].createElement(Bars, props));
}
var _default = exports["default"] = ActivitiesChartThumbnail;